import React, { Component } from 'react';
import { StoreProps } from 'store';
import getConfigurationByName from '../../selectors/getConfigurationByName';
import tableNames from '../../constants/tableNames';
import ItemConfiguration from '../../types/ItemConfiguration';
import { connect } from 'react-redux';
import { addPermissions, WithPermissions } from '../../decorators/addPermissions';
import { Messages } from '../../constants/rpcTypes';
import { withRouter } from 'react-router-dom';
import { WithRouterProps } from '../../decorators/withRouter';
import checkAccess from '../../decorators/checkAccess';
import { InternalDomainType } from './types';
import { openModal } from '../../actions/modal';
import { InternalDomain } from './InternalDomain';
import {
  addDataItem,
  deleteDataItem,
  updateDataItem,
} from '../../actions/getData';
import {
  deleteInternalDomainById,
} from '../../api/internalDomain';
import { addTranslation, IntlProps } from '../../decorators/addTranslation';

interface ConnectedProps {
  configuration: ItemConfiguration[];
  sort: {
    field: string;
    order: 'desc' | 'asc';
  };
  tableData: {
    items: InternalDomainType[];
    isFetch: boolean;
  };
}

interface State {
  isLoading: boolean;
}

type Props = ConnectedProps &
  IntlProps &
  StoreProps &
  WithPermissions &
  WithRouterProps<{ id?: string }>;

@checkAccess([Messages.InternalDomain_List])
class InternalDomainContainer extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    // @ts-ignore
    this.state = {
      isLoading: false,
    };
  }

  openEditModal = (data: any) => {
    const { dispatch } = this.props;

    dispatch(
      openModal({
        modalId: 'EditInternalDomain',
        content: { data },
        callback: (answer) => {
          const { data } = answer;
          const { isNew } = data;
          if (isNew) {
            dispatch(addDataItem(tableNames.internalDomains, data));
          } else {
            dispatch(updateDataItem(tableNames.internalDomains, 'id', data));
          }
        }
      })
    );
  };

  onDelete = async (id: number, domain: string): Promise<void> => {
    const { dispatch, getTranslate } = this.props;
    const text = getTranslate('internalDomains.modal.sureRemove');

    dispatch(
      openModal({
        modalId: 'Confirm',
        content: {
          text: text.replace('%%domain%%', domain),
        },
        callback: async (isOK) => {
          if (isOK) {
            this.setState({ isLoading: true });
            try {
              await deleteInternalDomainById(id);
              dispatch(deleteDataItem(tableNames.internalDomains, 'id', id));
            } finally {
              this.setState({ isLoading: false });
            }
          }
        },
      })
    );
  };

  render() {
    const { configuration } = this.props;

    if (!configuration) return null;

    return (
      <InternalDomain
        configuration={configuration}
        onEdit={this.openEditModal}
        onDelete={this.onDelete}
        isLoading={this.state.isLoading}
      />
    );
  }
}

const mapStateToProps = (state: {
  data: { [x: string]: any[]; internalDomains: any };
}): ConnectedProps => ({
  configuration: getConfigurationByName(state, tableNames.internalDomains),
  sort: state.data[tableNames.internalDomains].sort,
  tableData: state.data.internalDomains,
});

export default withRouter(
  connect(mapStateToProps)(
    addPermissions(addTranslation(InternalDomainContainer))
  )
);
